package com.macrofocus.eflux.context

enum class DisplayTooltip {
    Never,
    Probing,
    Selection // Implies Probing
}